module.exports = __webpack_public_path__ + "img/39.0f2a43b4.jpg";